var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskContinueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 3.15803C1.16663 2.34873 1.16663 1.94407 1.33537 1.72101C1.48237 1.52669 1.70706 1.40644 1.95029 1.39192C2.22949 1.37525 2.56618 1.59971 3.23956 2.04863L12.0025 7.89061C12.5589 8.26154 12.8371 8.44701 12.9341 8.68078C13.0188 8.88516 13.0188 9.11485 12.9341 9.31923C12.8371 9.553 12.5589 9.73847 12.0025 10.1094L3.23956 15.9514C2.56618 16.4003 2.22949 16.6248 1.95029 16.6081C1.70706 16.5936 1.48237 16.4733 1.33537 16.279C1.16663 16.0559 1.16663 15.6513 1.16663 14.842V3.15803Z",
    stroke: "#FEFDFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskContinueIcon);
export default __webpack_public_path__ + "static/media/TaskContinueIcon.626021f5b0992df0b261898fce7f69d1.svg";
export { ForwardRef as ReactComponent };